import { WALLET_TERMS_AND_CONDITIONS_LINKS } from 'constants/wallet';

export const getWalletTermsUrl = country =>
  WALLET_TERMS_AND_CONDITIONS_LINKS[country] || WALLET_TERMS_AND_CONDITIONS_LINKS.default;

export const formatPresetAmount = (amount, symbol) => `${symbol}${amount.toLocaleString()}`;
